import React, { useRef, useState } from "react";
import { Col, Form, Modal, Row } from "react-bootstrap";
import SbCancelBtn, { SBSaveUpdateBtn } from "../../Buttons/Buttons";
import eyeClose from '../../../assets/images/Login/eye-close.svg';
import eyeOpen from '../../../assets/images/Login/eye-open.svg';
import { useDispatch, useSelector } from "react-redux";
import { loadProfileChangePasswordOtp, postProfileSettingsSetPasswordDatas } from "../../../redux/action";
import * as HeaderAuthentication from '../../HeaderAuthentication'

const SetPasswordModal = (props) => {

    const dispatch = useDispatch();
    const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
    const storedSignInType = signInDetails ? signInDetails[0].SignInType : null;
    const { getProfilePasswordOtp } = useSelector((state) => state.data);
    console.log(getProfilePasswordOtp, 'getProfilePasswordOtp')

    const [oldPasswordType, setOldPasswordType] = useState("password");
    const [newPasswordType, setNewPasswordType] = useState("password");
    const [confirmPasswordType, setConfirmPasswordType] = useState("password");
    const [showOtpInput, setShowOtpInput] = useState(false); // State to toggle between password and OTP views

    // Input field values
    const [oldPassword, setOldPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");

    // Error states
    const [errors, setErrors] = useState({});
    const [otpError, setOtpError] = useState("");  // State to hold OTP error m

    const [otp, setOtp] = useState(new Array(6).fill(''));
    const inputRefs = useRef(new Array(6));

    const togglePassword = (field) => {
        switch (field) {
            case 'old':
                setOldPasswordType(oldPasswordType === "password" ? "text" : "password");
                break;
            case 'new':
                setNewPasswordType(newPasswordType === "password" ? "text" : "password");
                break;
            case 'confirm':
                setConfirmPasswordType(confirmPasswordType === "password" ? "text" : "password");
                break;
            default:
                break;
        }
    };

    // New password validation regex: 8-15 characters, at least 1 uppercase letter, at least 1 special character
    const passwordRegex = /^(?=.*[A-Z])(?=.*[\W_]).{8,15}$/;
    const handleGetOtpClick = () => {
        if (!validateForm()) return;
        // Validate the new password
        if (!passwordRegex.test(newPassword)) {
            setErrors({ newPassword: "Password must be 8-15 characters, include at least one uppercase letter and one special character" });
            return; // Stop further execution if validation fails
        }

        setShowOtpInput(true); // Show OTP input when Get OTP is clicked
        dispatch(loadProfileChangePasswordOtp());
    };

    const handleOtpChange = (index, value) => {
        const newOtp = [...otp];
        newOtp[index] = value;
        setOtp(newOtp);

        // Clear OTP error when user starts entering the OTP
        if (otpError) {
            setOtpError("");
        }

        if (value.length === 1 && index < 5) {
            inputRefs.current[index + 1].focus();
        }
    };

    const handleKeyDown = (index, e) => {
        if (e.key === 'Backspace' && otp[index] === '') {
            if (index > 0) {
                inputRefs.current[index - 1].focus();
            }
        }
    };

    const validateForm = () => {
        let validationErrors = {};

        if (!oldPassword) validationErrors.oldPassword = "Old Password is required";
        if (!newPassword) validationErrors.newPassword = "New Password is required";
        if (!confirmPassword) validationErrors.confirmPassword = "Confirm Password is required";
        if (newPassword && confirmPassword && newPassword !== confirmPassword) {
            validationErrors.confirmPassword = "Passwords do not match";
        }

        setErrors(validationErrors);
        return Object.keys(validationErrors).length === 0;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const enteredOtp = otp.join(""); // Convert OTP array to string

        // If OTP entered is invalid, show error
        if (enteredOtp !== getProfilePasswordOtp) {
            setOtpError("Invalid OTP. Please try again.");
            return;
        }

        // Clear OTP error if OTP is valid
        setOtpError("");

        // if (!validateForm()) return;

        let CustomerID = null;
        if (signInDetails[0].SignInType === "SuperAdmin") {
            CustomerID = signInDetails[0].SuperAdminID;
        } else if (signInDetails[0].SignInType === "ClientAdmin") {
            CustomerID = signInDetails[0].CompanyID;
        } else if (signInDetails[0].SignInType === "User") {
            CustomerID = signInDetails[0].UserID;
        }

        const data = {
            "SigninType": storedSignInType,
            "SigninID": CustomerID,
            "Password": newPassword,
            "OldPassword": oldPassword
        };

        let requestOption = {
            method: "POST",
            mode: "cors",
            headers: HeaderAuthentication.postExcomatixAuth,
            body: JSON.stringify(data),
        };
        dispatch(postProfileSettingsSetPasswordDatas(requestOption, props.handleCloseModal));
    };

    // Clear errors when user starts typing
    const handleInputChange = (field, value) => {
        if (field === "oldPassword") {
            setOldPassword(value);
            if (errors.oldPassword) setErrors({ ...errors, oldPassword: "" });
        } else if (field === "newPassword") {
            setNewPassword(value);
            if (errors.newPassword) setErrors({ ...errors, newPassword: "" });
        } else if (field === "confirmPassword") {
            setConfirmPassword(value);
            if (errors.confirmPassword) setErrors({ ...errors, confirmPassword: "" });
        }
    };

    return (
        <Modal show={props.open} onHide={props.handleCloseModal} className='save-custom-view-modal'>
            <Modal.Header closeButton>
                <Modal.Title>Set Password</Modal.Title>
            </Modal.Header>
            <Modal.Body className={!showOtpInput ? '' : 'set-password-container'}>
                {!showOtpInput ? (
                    <>
                        <Row className='customer-view-form-fields'>
                            <Col md={6} className='user-profile-form-col'>
                                <Form.Group controlId="formOldPassword" className="profile-password-container" autoComplete="off">
                                    <Form.Label>Enter Old Password</Form.Label>
                                    <Form.Control
                                        type={oldPasswordType}
                                        autoComplete="new-password"
                                        value={oldPassword}
                                        onChange={(e) => handleInputChange("oldPassword", e.target.value)}
                                    />
                                    <div className="pass-hide-show" onClick={() => togglePassword('old')}>
                                        {oldPasswordType === "password" ? (
                                            <img src={eyeClose} alt="Show Password" />
                                        ) : (
                                            <img src={eyeOpen} alt="Hide Password" />
                                        )}
                                    </div>
                                    {errors.oldPassword && <span className="text-danger">{errors.oldPassword}</span>}
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row className='customer-view-form-fields mt-2'>
                            <Col md={6} className='user-profile-form-col'>
                                <Form.Group controlId="formNewPassword" className="profile-password-container">
                                    <Form.Label>New Password</Form.Label>
                                    <Form.Control
                                        autoComplete="new-password"
                                        type={newPasswordType}
                                        value={newPassword}
                                        onChange={(e) => handleInputChange("newPassword", e.target.value)}
                                    />
                                    <div className="pass-hide-show" onClick={() => togglePassword('new')}>
                                        {newPasswordType === "password" ? (
                                            <img src={eyeClose} alt="Show Password" />
                                        ) : (
                                            <img src={eyeOpen} alt="Hide Password" />
                                        )}
                                    </div>
                                    {errors.newPassword && <span className="text-danger">{errors.newPassword}</span>}
                                </Form.Group>
                            </Col>
                            <Col md={6} className='user-profile-form-col'>
                                <Form.Group controlId="formConfirmPassword" className="profile-password-container">
                                    <Form.Label>Confirm Password</Form.Label>
                                    <Form.Control
                                        autoComplete="new-password"
                                        type={confirmPasswordType}
                                        value={confirmPassword}
                                        onChange={(e) => handleInputChange("confirmPassword", e.target.value)}
                                    />
                                    <div className="pass-hide-show" onClick={() => togglePassword('confirm')}>
                                        {confirmPasswordType === "password" ? (
                                            <img src={eyeClose} alt="Show Password" />
                                        ) : (
                                            <img src={eyeOpen} alt="Hide Password" />
                                        )}
                                    </div>
                                    {errors.confirmPassword && <span className="text-danger">{errors.confirmPassword}</span>}
                                </Form.Group>
                            </Col>
                        </Row>
                    </>
                ) : (
                    <>
                        <p className="profile-otp-form-text">Enter your One-Time Password to verify your phone number</p>
                        <Form className='profile-otp-form'>
                            <div className='otp-input-box'>
                                {otp.map((value, index) => (
                                    <Form.Control
                                        key={index}
                                        type="password"
                                        value={value}
                                        maxLength={1}
                                        className="form-control-profile-otp-input"
                                        ref={(input) => (inputRefs.current[index] = input)}
                                        onChange={(e) => handleOtpChange(index, e.target.value)}
                                        onKeyDown={(e) => handleKeyDown(index, e)}
                                    />
                                ))}
                            </div>
                        </Form>
                        {otpError && <span className="text-danger">{otpError}</span>}
                    </>
                )}
            </Modal.Body>
            <Modal.Footer>
                <SbCancelBtn btnName="Cancel" onClickEffect={props.handleCloseModal} />
                {!showOtpInput ? (
                    <SBSaveUpdateBtn btnName="Get OTP"
                        onClickEffect={handleGetOtpClick}

                    />
                ) : (
                    <SBSaveUpdateBtn btnName="Submit" onClickEffect={handleSubmit} />
                )}
            </Modal.Footer>
        </Modal>
    );
};

export default SetPasswordModal;
